import { render, staticRenderFns } from "./writeoffPeople.vue?vue&type=template&id=cb40c500&scoped=true&"
import script from "./writeoffPeople.vue?vue&type=script&lang=js&"
export * from "./writeoffPeople.vue?vue&type=script&lang=js&"
import style0 from "./writeoffPeople.vue?vue&type=style&index=0&id=cb40c500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb40c500",
  null
  
)

export default component.exports